import script from "./TopUserPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./TopUserPanel.vue?vue&type=script&setup=true&lang=ts"

import "./TopUserPanel.vue?vue&type=style&index=0&id=17a5def0&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17a5def0"]])

export default __exports__